import type { ReactNode } from "react";

type CollapsibleProps = {
  title: string;
  /** Shown beside the title and still visible when collapsed — e.g. a subtotal. */
  summary?: string;
  count?: number;
  defaultOpen?: boolean;
  children: ReactNode;
};

/**
 * A collapsible section. Built on <details>/<summary> rather than useState so it is
 * keyboard-operable, exposed to assistive tech, and findable by the browser's own
 * in-page search — all of which a div-and-onClick version would have to reimplement.
 */
export function Collapsible({
  title,
  summary,
  count,
  defaultOpen = true,
  children,
}: CollapsibleProps) {
  return (
    <details className="fold" open={defaultOpen}>
      <summary className="fold-head">
        <span className="fold-chevron" aria-hidden="true" />
        <span className="fold-title">{title}</span>
        {count !== undefined && <span className="section-count">{count}</span>}
        {summary && <span className="fold-summary">{summary}</span>}
      </summary>
      <div className="fold-body">{children}</div>
    </details>
  );
}
